export const banner = {
  getBanner: "banner/getAllWEB",
  getBannerByEventName: "/banner/getBanner"
};
